import React, { useState } from 'react';
import config from '../../../../config.json';
import './OpalHostSection.css';
import OpalSectionBaseVisual from '../OpalSectionBaseVisual/OpalSectionBaseVisual';

const OpalHostSection = ({ section, palettes, themes, heightPerRow }) => {
  const [isHoveringChartContent, setIsHoveringChartContent] = useState(false);

  let height = heightPerRow * section.rows;
  let addSpacing = section.rows > 1 ? (section.rows - 1) * 0.5 : 0; //The 0.5 is the 0.5rem gap of grid effective for more than 1 row
  return (
    <div
      className={`opal-host-section ${isHoveringChartContent ? 'show-toolbar' : 'hide-toolbar'}`}
      style={{
        height: `${height + addSpacing}rem`,
        padding: '0.9375rem',
        display: 'flex',
        justifyContent: 'center'
      }}
      onMouseEnter={() => setIsHoveringChartContent(true)}
      onMouseLeave={() => setIsHoveringChartContent(false)}>
      <div className='section-visual' style={{ width: '100%' }}>
        <OpalSectionBaseVisual visual={section.visual} columnSize={section.columns} rowSize={section.rows} palettes={palettes} themes={themes} isModal={false} />
      </div>
    </div>
  );
};

export default OpalHostSection;